import React, { Component } from "react";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "datatables.net-dt/css/jquery.dataTables.css";
import "jspdf-autotable";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";

import DateTimeService from "../../../../utils/dateTimeService";
import { getUserId, main_url } from "../../../../utils/CommonFunction";
import {
  petrolPrintStatusUpdate,
  petrolRequest,
} from "../../../../utils/apiRoutes";
import { getApi, getHeaders } from "../../../../utils/apiHelper";
import * as jsPDF from "jspdf";
import { imgData } from "../../../../utils/Global";
import apiRoutes from "../../../../utils/apiRoutes";
import moment from "moment";
import FiltersByStatusRow from "../components/FiltersByStatusRow";

const $ = require("jquery");
const jzip = require("jzip");
window.JSZip = jzip;
$.DataTable = require("datatables.net-bs4");
$.DataTable = require("datatables.net-responsive-bs4");
$.DataTable = require("datatables.net");
require("datatables.net-buttons/js/dataTables.buttons.min");
require("datatables.net-buttons/js/buttons.html5.min");

export default class PetrolRequestsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: getUserId("user_info"),
    };
  }

  componentDidMount() {
    this._setTableData();

    const that = this;
    $("#dataTables-petrolRequests").on("click", "#toView", function () {
      let data = $(this).find("#view").text();
      data = JSON.parse(data);

      that.props.onViewDetail(that.props.petrolRequests[data]);
    });
    $("#dataTables-petrolRequests").on("click", "#toEdit", function () {
      let data = $(this).find("#edit").text();
      data = JSON.parse(data);

      that.props.onEditDetail(that.props.petrolRequests[data]);
    });
    $("#dataTables-petrolRequests").on("click", "#toPrint", function () {
      let data = $(this).find("#print").text();
      data = JSON.parse(data);

      that.handlePrint(that.props.petrolRequests[data]);
    });
  }

  componentDidUpdate() {
    this._setTableData();
  }

  getPetrolDetails = async (petrolApplicationId) => {
    const res = await fetch(`${petrolRequest}/${petrolApplicationId}`, {
      headers: getHeaders(),
    });
    if (res.ok) {
      return res.json();
    } else {
      this.setState({
        isLoading: false,
      });
      this.showError("Something went wrong... Couldn't load petrol details!");
      return null;
    }
  };

  updatePrintStatus = async (petrolApplicationId) => {
    await fetch(`${petrolPrintStatusUpdate}/${petrolApplicationId}`, {
      method: "POST",
      headers: getHeaders(),
    });
  };

  async getFormApprovalParticipants(petrolApplicationId, formNo) {
    const res = await getApi(
      apiRoutes.getFormApprovalParticipants(
        "petrol",
        petrolApplicationId,
        formNo
      )
    );
    if (res) {
      return res.data;
    }
  }

  async getEamPaymentInfo(formNo) {
    let type = "Petrol";
    const res = await fetch(
      `${main_url}eam_payment/getEamPaymentInfo/${formNo}/${type}`,
      {
        headers: getHeaders(),
      }
    );
    return await res.json();
  }

  async handlePrint(data) {
    const info = { ...data };
    let details;
    const dataList = await Promise.all([
      this.getPetrolDetails(info.petrol_application_id),
      this.getFormApprovalParticipants(
        info.petrol_application_id,
        info.form_no
      ),
      this.getEamPaymentInfo(info.form_no),
    ]);
    const detailsData = dataList[0];
    const hrmFormApprovalLogs = dataList[1];
    const lastHRMFormApprovalData = hrmFormApprovalLogs[0]; // Only take the recent approval (There might be several referbacks)
    const eamPaymentInfo = dataList[2];
    console.log(lastHRMFormApprovalData);
    console.log(eamPaymentInfo);

    if (detailsData && detailsData.data && detailsData.data.details) {
      details = [...detailsData.data.details];
    }

    const doc = new jsPDF("l", "mm", "a4");
    const today = new DateTimeService().todayDate;
    doc.setFontSize(12);
    doc.addImage(imgData, "image/jpeg", 15, 10, 50, 20);
    doc.text("HR_0029", 200, 22);
    doc.text("Petrol Form", 200, 31);
    doc.text("Generate Date: " + today, 15, 40);
    doc.text("Voucher No: PR" + info.form_no, 200, 40);
    doc.text("Request Date: " + info.request_date, 15, 55);
    doc.text("Vehicle Type: " + info.vehicle_type_name, 150, 55);
    doc.text("Plate Number: " + info.plate_number, 15, 65);
    doc.text("Withdrawal Location: " + info.withdrawal_location_name, 150, 65);
    var cols = [
      "Actual Date",
      "Start Location",
      "Destination",
      "Trip Type",
      "Start Mileage",
      "End Mileage",
      "Total (km)",
      "Personal Used (km)",
      "Company Used (km)",
      "Amount",
      "Purpose",
      "Remark",
    ];
    var rows = details.map((detail) => [
      detail.actual_date,
      detail.start_location,
      detail.destination,
      detail.trip_type.label,
      detail.start_mileage,
      detail.end_mileage,
      detail.total_km,
      detail.personal_use_km,
      detail.company_use_km,
      detail.amount,
      detail.purpose,
      detail.remark,
    ]);
    doc.autoTable(cols, rows, { startY: 75 });
    if (doc.previousAutoTable.finalY > 140) {
      doc.addPage();
      doc.previousAutoTable.finalY = 0;
    }
    doc.text(
      "Total Kilometer: " + info.total_km,
      15,
      doc.previousAutoTable.finalY + 15
    );
    doc.text(
      "Total Amount: " + info.total_amount,
      100,
      doc.previousAutoTable.finalY + 15
    );
    doc.setFontSize(10);
    doc.setFontType("bold");
    doc.text("Request By", 15, doc.previousAutoTable.finalY + 30);
    doc.text("Check By", 70, doc.previousAutoTable.finalY + 30);
    doc.text("Verify By", 120, doc.previousAutoTable.finalY + 30);
    doc.text("Approve By", 170, doc.previousAutoTable.finalY + 30);
    doc.setFontSize(9);
    doc.setFontType("normal");
    doc.text(
      moment
        .parseZone(lastHRMFormApprovalData[0].date_time)
        .format("YYYY-MM-DD HH:mm:ss"),
      15,
      doc.previousAutoTable.finalY + 37
    );
    doc.text(
      moment
        .parseZone(lastHRMFormApprovalData[1].date_time)
        .format("YYYY-MM-DD HH:mm:ss"),
      70,
      doc.previousAutoTable.finalY + 37
    );
    doc.text(
      moment
        .parseZone(lastHRMFormApprovalData[2].date_time)
        .format("YYYY-MM-DD HH:mm:ss"),
      120,
      doc.previousAutoTable.finalY + 37
    );
    doc.text(
      moment
        .parseZone(lastHRMFormApprovalData[3].date_time)
        .format("YYYY-MM-DD HH:mm:ss"),
      170,
      doc.previousAutoTable.finalY + 37
    );

    doc.text(
      lastHRMFormApprovalData[0].employment_id,
      15,
      doc.previousAutoTable.finalY + 42
    );
    doc.text(
      lastHRMFormApprovalData[1].employment_id,
      70,
      doc.previousAutoTable.finalY + 42
    );
    doc.text(
      lastHRMFormApprovalData[2].employment_id,
      120,
      doc.previousAutoTable.finalY + 42
    );
    doc.text(
      lastHRMFormApprovalData[3].employment_id,
      170,
      doc.previousAutoTable.finalY + 42
    );
    doc.text(
      lastHRMFormApprovalData[0].fullname,
      15,
      doc.previousAutoTable.finalY + 47
    );
    doc.text(
      lastHRMFormApprovalData[1].fullname,
      70,
      doc.previousAutoTable.finalY + 47
    );
    doc.text(
      lastHRMFormApprovalData[2].fullname,
      120,
      doc.previousAutoTable.finalY + 47
    );
    doc.text(
      lastHRMFormApprovalData[3].fullname,
      170,
      doc.previousAutoTable.finalY + 47
    );
    doc.text(
      lastHRMFormApprovalData[0].branch_name,
      15,
      doc.previousAutoTable.finalY + 52
    );
    doc.text(
      lastHRMFormApprovalData[1].branch_name,
      70,
      doc.previousAutoTable.finalY + 52
    );
    doc.text(
      lastHRMFormApprovalData[2].branch_name,
      120,
      doc.previousAutoTable.finalY + 52
    );
    doc.text(
      lastHRMFormApprovalData[3].branch_name,
      170,
      doc.previousAutoTable.finalY + 52
    );
    doc.text(
      lastHRMFormApprovalData[0].designation,
      15,
      doc.previousAutoTable.finalY + 57
    );
    doc.text(
      lastHRMFormApprovalData[1].designation,
      70,
      doc.previousAutoTable.finalY + 57
    );
    doc.text(
      lastHRMFormApprovalData[2].designation,
      120,
      doc.previousAutoTable.finalY + 57
    );
    doc.text(
      lastHRMFormApprovalData[3].designation,
      170,
      doc.previousAutoTable.finalY + 57
    );

    doc.save("PetrolRequest.pdf");
    if (!info.print) this.updatePrintStatus(info.petrol_application_id);
    doc.autoPrint();
    window.open(doc.output("bloburl"), "_blank");
  }

  showError = (message) => {
    this.props.showError(message);
  };

  _setTableData() {
    let table;
    let list = [];
    let obj,
      one = [];

    let petrolRequests = this.props.petrolRequests;

    const permission = this.props.permission;
    const has_action =
      permission.isView === 1 || permission.isEdit === 1 ? true : false;

    for (let i = 0; i < petrolRequests.length; i++) {
      obj = petrolRequests[i];

      let status = "";
      if (obj.status === 0) {
        status =
          '<small class="label label-warning" style="background-color:#509aed"> Request </small>';
      } else if (obj.status === 1) {
        status =
          '<small class="label label-warning" style="background-color:#b33ce0"> Check </small>';
      } else if (obj.status === 2) {
        status =
          '<small class="label label-warning" style="background-color:#f2a509"> Verify </small>';
      } else if (obj.status === 3) {
        status =
          '<small class="label label-warning" style="background-color:#29a50a"> Approve </small>';
      } else if (obj.status === 4) {
        status =
          '<small class="label label-warning" style="background-color:#f60e2f"> Reject </small>';
      } else if (obj.status === 5) {
        status =
          '<small class="label label-warning" style="background-color:#cc0066"> ReferBack </small>';
      } else if (obj.status === 22) {
        status =
          '<small class="label label-warning" style="background-color:#db26de"> Pending For Payment </small>';
      } else if (obj.status === 27) {
        status =
          '<small class="label label-warning" style="background-color:#ed5565"> Payment Reject </small>';
      } else if (obj.status === 18) {
        status =
          '<small class="label label-warning" style="background-color:#c9a812"> Payment Approve </small>';
      } else if (obj.status === 19) {
        status =
          '<small class="label label-warning" style="background-color:#4ab510"> Payment Receive </small>';
      } else if (obj.status === 25) {
        status =
          '<small class="label label-warning" style="background-color:#008A5F"> Payment Finish </small>';
      } else if (obj.status === 28) {
        status =
          '<small class="label label-warning" style="background-color:#cc0066"> Payment Refer Back </small>';
      } else if (obj.status === 31) {
        status =
          '<small class="label label-warning" style="background-color:#cc0080"> Payment Receive Refer Back </small>';
      }

      one = {
        no: i + 1,
        form_no: `PR${obj.form_no}`,
        employee_id: obj.employee_id,
        fullname: obj.fullname,
        position_name: obj.position_name,
        department_name: obj.department_name,
        branch_name: obj.branch_name,
        region_name: obj.region_name,
        request_date: new DateTimeService(obj.request_date).formatDate,
        vehicle_type_name: obj.vehicle_type_name,
        plate_number: obj.plate_number,
        total_km: obj.total_km,
        total_amount: obj.total_amount,
        status: status,
      };

      if (has_action) {
        if (
          obj.status === 0 ||
          obj.status === 1 ||
          obj.status === 2 ||
          obj.status === 4 ||
          obj.status === 5 ||
          obj.status === 28
        ) {
          one.action =
            permission.isView === 1
              ? '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toView" ><span id="view" class="hidden" >' +
                i +
                '</span>  <i className="fa fa-cogs"></i>&nbsp;View</button>'
              : "";
          one.action +=
            (obj.status !== 4 && permission.isEdit === 1) ||
            (obj.status === 5 && obj.createdBy === this.state.userId)
              ? '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toEdit" ><span id="edit" class="hidden" >' +
                i +
                '</span>  <i className="fa fa-cogs"></i>&nbsp;Edit</button>'
              : "";
        } else {
          one.action =
            permission.isView === 1
              ? '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toView" ><span id="view" class="hidden" >' +
                i +
                '</span>  <i className="fa fa-cogs"></i>&nbsp;View</button>'
              : "";

          one.action += !obj.print
            ? '<button style="margin-right:10px" class="btn btn-info btn-sm own-btn-edit" id="toPrint" ><span id="print" class="hidden" >' +
              i +
              '</span>  <i className="fa fa-cogs"></i>&nbsp;Print</button>'
            : '<button style="margin-right:10px" class="btn btn-info btn-sm own-btn-edit" id="toPrint" ><span id="print" class="hidden" >' +
              i +
              '</span>  <i className="fa fa-cogs"></i>&nbsp;Printed</button>';
        }
      }

      list.push(one);
    }

    if ($.fn.dataTable.isDataTable("#dataTables-petrolRequests")) {
      table = $("#dataTables-petrolRequests").dataTable();
      table.fnClearTable();
      table.fnDestroy();
      $("#dataTables-petrolRequests").empty();
    }

    let column = [
      { title: "No", data: "no" },
      { title: "Form No", data: "form_no" },
      { title: "Employee ID", data: "employee_id" },
      { title: "Employee Name", data: "fullname" },
      { title: "Position", data: "position_name" },
      { title: "Department", data: "department_name" },
      { title: "Branch", data: "branch_name" },
      { title: "Region", data: "region_name" },
      { title: "Request Date", data: "request_date" },
      { title: "Vehicle Type", data: "vehicle_type_name" },
      { title: "Plate Number", data: "plate_number" },
      { title: "Total Kilometer", data: "total_km" },
      { title: "Total Amount", data: "total_amount" },
      { title: "Status", data: "status" },
    ];

    if (has_action) {
      column.push({ title: "Action", data: "action" });
    }

    table = $("#dataTables-petrolRequests").DataTable({
      pageLength: 20,
      autofill: true,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      paging: true,
      dom: "Bfrtip",
      buttons: ["copy", "csv", "excel", "pdf"],
      data: list,
      columns: column,
    });
  }

  render() {
    return (
      <div
        style={{
          marginLeft: 15,
          marginRight: 15,
        }}
      >
        <div style={{ marginBottom: 15 }}>
          <FiltersByStatusRow filterByStatus={this.props.filterByStatus} />
        </div>
        <div className="margin-y">
          <table
            width="99%"
            className="table table-striped table-bordered table-hover table-responsive nowrap dt-responsive rm-marginTop"
            id="dataTables-petrolRequests"
          ></table>
        </div>
      </div>
    );
  }
}
